import { AssignBodyRequest, AssignRequest, AssignResponse } from '@eigtech/assignments-types'
import { contextualPost } from '@eigtech/ui-shared-api'
import { assignmentsBasePath } from './constants'

export const assign = ({ assignableId, ...body }: AssignRequest) =>
  contextualPost<AssignResponse, AssignBodyRequest>(
    `${assignmentsBasePath}/${assignableId}`,
    body,
    {
      responseType: 'none',
    }
  )
